import { useRef, useState } from "react";
import { Modal, Button, Group, Text, ActionIcon} from "@mantine/core";
import { TextInput, LoadingOverlay } from "@mantine/core";
// import { GenderPicker } from "./GenderPicker";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";
import { showNotification } from "@mantine/notifications";
import { OTPModal } from "./OTPModal";

import { lcaSendOtp } from "../../api/lcaAuth";
import { useEffect } from "react";
// import { getRegistrationStatus } from "../../api/settings";

export function OTPRollNoModal() {
  const [opened, setOpened] = useState(false);
  const [rollNo, setRollNo] = useState("");
  const [timer, setTimer] = useState(0);
  const rollRef = useRef("");
  const [openOTP, setOpenOTP] = useState(false);
  // const [regStatus, setRegStatus] = useState(false);
  //   const [token, setToken] = useState();
  const [userLoad, setUserLoad] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();


  const downloadInstructions = () => {
    const fileUrl = `./Instructions.pdf`;
    const anchorElement = document.createElement("a");
    anchorElement.href = fileUrl;
    anchorElement.download = "instructions.pdf";
    anchorElement.click();
  }

  useEffect(() => {
    setRollNo("");
    // const fetchSetting = async () => {
    //   const res = await getRegistrationStatus();
    //   setRegStatus(res.data.isRegistrationOpen);
    //   // console.log(res.data.isRegistrationOpen);
    // };
    // fetchSetting();
  }, []);

  useEffect(() => {
    rollRef.current = rollNo;
  }, [rollNo]);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      // console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("yourAction");
    // console.log(token);

    // Do whatever you want with the token
    // console.log(rollRef.current);
    //  Route to send otp
    const data = {
      roll: rollRef.current,
      recaptcha: token,
    };
    try {
      setUserLoad(true);
      const res = await lcaSendOtp(data);
      console.log(data.roll,"Here is the typed one");
      setUserLoad(false);
      // console.log(res);
      if (res.status == 200) {
        // Avoid storing in localStorage
        localStorage.setItem("roll", rollRef.current);
        //console.log(res.data.expiresIn);
        // setTimer(res.data.expiresIn);
        setTimer(9.5);
        setOpened(false);
        setOpenOTP(true);
        showNotification({
          title: "OTP Verification",
          message: "OTP has been sent successfully to your Lynx Account",
          styles: (theme) => ({
            root: {
              backgroundColor: theme.colors.blue[6],
              borderColor: theme.colors.blue[6],

              "&::before": { backgroundColor: theme.white },
            },

            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
              "&:hover": { backgroundColor: theme.colors.blue[7] },
            },
          }),
        });
      }
    } catch (err) {
      setUserLoad(false);
      console.log(err.response.data.message);
      showNotification({
        // title: "OTP Verification",
        message: `${err.response.data.message}`,
        styles: (theme) => ({
          root: {
            backgroundColor: theme.colors.red[6],
            borderColor: theme.colors.red[6],

            "&::before": { backgroundColor: theme.white },
          },

          title: { color: theme.white },
          description: { color: theme.white },
          closeButton: {
            color: theme.white,
            "&:hover": { backgroundColor: theme.colors.blue[7] },
          },
        }),
      });
    }
  }, [executeRecaptcha]);

  return (
    <>
      {
        <>
          <OTPModal
            openOTP={openOTP}
            setOpenOTP={setOpenOTP}
            rollNo={rollRef.current}
            timer={timer}
          />
        </>
      }
      <Modal
        opened={opened}
        withCloseButton={false}
        closeOnEscape={true}
        onClose={() => setOpened(false)}
        styles={{
          modal: { backgroundColor: "#fff" },
        }}
      >
        <LoadingOverlay  visible={userLoad}/>
        {/* Modal content */}
        {/* {regStatus && (
          <>
            <Text weight={"bold"}> Registration process </Text>
            <Text>1. OTP will be sent to your Lynx.</Text>
            <Text>2. Enter the OTP you got from the Lynx.</Text>
            <Text>3. Choose domain and confirm your details.</Text>
          </>
        )} */} 

        <Group position="apart">
          <Text style={{ color: "#1C3351" }} size="xl" weight={700}>
            Login
          </Text>
          <Button
            variant="outline"
            radius="md"
            onClick={() => setOpened(false)}
            style={{ color: "#1C3351", border: "1px solid #1C3351" }}
          >
            Back
          </Button>
        </Group>

        <Group
          styles={{
            root: {
              border: "1px solid #0092E4",
              borderRadius: "5px",
              marginTop: "10px",
              padding: "10px",
              display: "grid",
              gridTemplateColumns: "0.5fr 5fr",
            },
          }}
        >
          <ActionIcon
            styles={{
              root: {
                "&:hover": {
                  backgroundColor: "transparent",
                },
                pointerEvents: "none",
              },
            }}
          >
            <img src="./info.png" alt="Lynx Logo" height={200} width={200} />
          </ActionIcon>
          <Text color="black" size="xl">
            The Registration for Spider Induction will begin shortly
            Click on the link, to download step-by-step{" "}
            <u style={{ cursor: "pointer" }} onClick={downloadInstructions}>instructions</u>.
          </Text>
        </Group>

        {/* <Text>{regStatus ? "" : "Registration closed"}</Text> */}
        <TextInput
          label="Roll Number"
          value={rollNo}
          onChange={(e) => setRollNo(e.target.value)}
          placeholder="Enter your roll number"
          // disabled={!regStatus}
          placeholderTextColor="red"
          mt="md"
          styles={{
            input: {
              backgroundColor: "#EFF7FF",
              borderRadius: "5px",
              border: "1px solid #0092E4",
              color: "#0092E4",
              "::placeholder": { color: "#0092E4" },
              fontSize: "15px",
            },
            label: { color: "#1C3351" },
          }}
        />

        <Button
          mt="xl"
          onClick={handleReCaptchaVerify}
          // disabled={!regStatus}
          size="sm"
          styles={{
            root: {
              backgroundColor: "#0063F8",
              borderRadius: "20px",
              display: "flex",
              margin: "0 auto",
              padding: "10 20",
            },
          }}
        >
          <img
            src="./lynx-logo.png"
            alt="Lynx Logo"
            height={30}
            width={35}
            minWidth={"fit-content"}
          />
          LOGIN WITH LYNX AUTH
        </Button>
      </Modal>

      <Group position="center">
        <button
          style={{ zIndex: 6 }}
          id="registerBtn"
          onClick={() => {
            // console.log(opened);

            setOpened(true);
          }}
        >
          LOGIN
        </button>
        {/* <Button radius="xl" sx={{ height: 30 }} onClick={() => setOpened(true)}>
          New User ?
        </Button> */}
      </Group>
    </>
  );
}

const reCaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function Login() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={reCaptchaSiteKey}
      scriptProps={{ async: true }}
    >
      <OTPRollNoModal />
    </GoogleReCaptchaProvider>
  );
}